import { render, staticRenderFns } from "./HeaderYoutube.vue?vue&type=template&id=fd3d67fa&scoped=true&"
import script from "./HeaderYoutube.vue?vue&type=script&lang=js&"
export * from "./HeaderYoutube.vue?vue&type=script&lang=js&"
import style0 from "./HeaderYoutube.vue?vue&type=style&index=0&id=fd3d67fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d67fa",
  null
  
)

export default component.exports